import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers(['root', 'icon', 'title', 'description', 'link', 'linkWrapper']);

/**
 * @typedef {import('@chakra-ui/styled-system').PartsStyleInterpolation<{
 *  keys: ("root" | "icon" | "title" | "description" | "link" | "linkWrapper")[]
 * }>} IconStyles
 */
export const iconStyles = helpers.defineMultiStyleConfig({
  /**
   * @param {Object} args - Component arguments
   * @param {Contentful.Icon} args.component - Icon component data
   * @param {boolean} [args.isComplete] - Whether component has all fields
   * @param {boolean} [args.isFetching] - Whether additional data is being fetched
   *
   * @returns {IconStyles} - Component styles
   */
  baseStyle({component}) {
    return {
      root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
      },
      icon: {
        maxWidth: '100%',
        maxHeight: '100%',
        width: 'auto',
        height: 'auto',
      },
      title: {
        marginTop: 4,
        textAlign: 'center',
        fontSize: {base: 'lg', lg: '22px'}, // 18px mobile, 22px desktop
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '120%', // 21.6px mobile, 26.4px desktop
        letterSpacing: {base: '0px', lg: '-0.01375rem'}, // 0px mobile, -0.22px desktop
      },
      description: {
        marginTop: 2,
        textAlign: 'center',
        fontSize: {base: 'xs', lg: 'md'}, // 12px mobile, 16px desktop
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: {base: '140%', lg: '160%'}, // 140% mobile, 160% desktop
      },
      link: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        textDecoration: 'none',
      },
      linkWrapper: {
        width: '100%',
      },
    };
  },
});
